import type { FirebaseConfigType } from './type';

export const FirebaseConfig: FirebaseConfigType = {
  apiKey: 'AIzaSyDf_l1BG7ZWowygDxN6QsYqQnMDPjpcIZg',
  authDomain: 'levii-balus-playground-2.firebaseapp.com',
  databaseURL: 'https://levii-balus-playground-2-default-rtdb.firebaseio.com',
  projectId: 'levii-balus-playground-2',
  storageBucket: 'levii-balus-playground-2.appspot.com',
  messagingSenderId: '1031027436631',
  appId: '1:1031027436631:web:aa3061a4d23941bd7ac712',
  measurementId: 'G-L0EMG9SM9P',
};
